import React, { createContext, useState, useContext, useEffect } from 'react';

const AuthContext = createContext();
export const AuthProvider = ({ children }) => {
  const userData = JSON.parse(sessionStorage.getItem('user'));

  const [user, setUser] = useState(userData);

  useEffect(() => {
    const storedUser = sessionStorage.getItem('user');
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
  }, []);

  useEffect(() => {
    const storedToken = sessionStorage.getItem('token');
    if (storedToken) {
      // Implement logic to validate token (e.g., send to server for verification)
      // If token is valid, set user state accordingly
      // setUser();
    }
  }, []);

  const login = (userData) => {
    setUser(userData);
    sessionStorage.setItem('user', JSON.stringify(userData));
  };

  const logout = () => {
    setUser(null);
    sessionStorage.removeItem('user');
    sessionStorage.removeItem('token');
  };

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
